import { Box } from '@mui/system'
import React from 'react'
import DataTable from '../../../Components/Data-Table'
const columns = [
  {
    "field": "id",
    "hide": true
  },
  {
    "field": "deviceName",
    "headerName": "Device Name",
    "width": 220
  },
  {
    "field": "label",
    "headerName": "Label",
    "width": 220,
    "editable": false
  },
  {
    "field": "room",
    "headerName": "Room",
    "width": 220,
    "editable": false
  },
  {
    "field": "status",
    "headerName": "Status",
    "width": 220,
    "editable": false
  }
]
const data = [
  {
    "id": "282dde16-b284-5e8b-8fa3-108792b4b491",
    "deviceName": "Biamp Tesira Forte VT",
    "label": "Digital Signal Processor",
    "room": "Technical Room",
    "status": "Connected",
  },
  {
    "id": "57d78100-a028-597a-8d0c-4678101f6339",
    "deviceName": "Poly G7500",
    "label": "Video Conference Codec",
    "room": "Conference Room",
    "status": "Disconnected",
  },
  {
    "id": "edab38f9-49ae-5451-9bbb-dbbf4741041e",
    "deviceName": "Samsung QM85R",
    "label": "UHD Display",
    "room": "Living Room",
    "status": "Connected",
  },
  {
    "id": "a757ba99-f689-5cf6-ba68-20f5a4d26761",
    "deviceName": "Sony Playstation 5",
    "label": "Game Console",
    "room": "Bedroom",
    "status": "Connected",
  },
  {
    "id": "6d121565-0a24-5d33-ba9b-26ecd9bc4045",
    "deviceName": "Hyundai HRU2022C30",
    "label": "Air Conditioner",
    "room": "Master Bedroom",
    "status": "Connected",
  },
  {
    "id": "6d121565-0a24-5d33-ba9b-26ecd9bc40245",
    "deviceName": "Hyundai HRU2022C30",
    "label": "Air Conditioner",
    "room": "Master Bedroom",
    "status": "Connected",
  }
]
const status = () => {
  return (
    <Box sx={{ mt: 4 }}>
      <DataTable data={data} columns={columns} />
    </Box>
  )
}

export default status